
import React from "react";
import { Button } from "@/components/ui/button";

interface SampleQuestionsProps {
  onExampleClick: (example: string) => void;
}

const SampleQuestions: React.FC<SampleQuestionsProps> = ({ onExampleClick }) => {
  const exampleDilemmas = [
    "What do I say when asked to support Pride Month at work?",
    "How do I respond when my friend comes out as transgender?",
    "What does the Bible say about abortion, really?",
    "Can I go to a same-sex wedding out of love for the person?",
    "How do I show compassion to people I disagree with morally?",
    "What if my convictions make me look judgmental or hateful?"
  ];

  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold text-[#403E43] mb-4">Common Questions</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {exampleDilemmas.map((dilemma, index) => (
          <Button 
            key={index} 
            variant="outline" 
            className="h-auto py-3 px-4 justify-start border-heaven-gold/20 text-heaven-gold hover:bg-heaven-gold/5 text-sm text-left whitespace-normal break-words"
            onClick={() => onExampleClick(dilemma)}
          >
            {dilemma}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SampleQuestions;
